<template>
  <div class="banner_img">
    <img v-for="(item,index) in bannerImg" v-lazy="item.image" :key="index" v-if="BannerType==item.type" >
  </div>
</template>

<script>
import {getPageBanner} from "../api/apis";

export default {
  props:{
    BannerType:{
      type:String
    }
  },
  name: "otherBanner",
  data(){
    return{
      bannerImg:[]
    }
  },
  mounted() {
      this.GetPageBanner()
  },
  methods:{
    GetPageBanner(){
      getPageBanner().then(res=>{
        this.bannerImg = res.data
      })
    }
  }
}
</script>

<style scoped lang="less">
  .banner_img{
    width: 100%;
    height: auto;
    max-height: 700px;
    overflow: hidden;
    img{
      width: 100%;
    }
  }

</style>